import React,{useRef} from 'react'

import bg from '../../../images/contribute.jpg'

const PopupHowToContribute = ({show}) => {

  const popupDefaultRef = useRef()

  return (
    <>
      {
        !show ? null : (
          <div className="popup-child" style={{display:`${show === 'How to contribute' ? '' : 'none'}`,opacity:`${show ? 1 : 0}`}}>
            <div className="popup-image-head" style={{background:`#000 url(${bg}) center center`,backgroundSize:'cover'}}>
              <div/>
              <section>
                <h6>How to contribute</h6>
                <small>Header photo: © Unsplash</small>
              </section>
            </div>
            <div className="popup-child-text">
              <p>
                If you would like to contribute to the database, please download the <a href="/forms/Consent-Form-CIFOR-WILDMEAT.docx" target="_blank" download><strong>Consent Form for Personal Data Provision</strong></a> document and then send the signed form by email to <a href="mailto:info@wildmeat.org" target="_blank" rel="noreferrer">info@wildmeat.org</a>.
              </p>
              <p>
                If have spotted an error that you would like to point out, please email: <a href="mailto:info@wildmeat.org" target="_blank" rel="noreferrer">info@wildmeat.org</a>
              </p>
            </div>
          </div>
        )
      }
    </>
  )
}
export default PopupHowToContribute
